// src/components/ResetFiltersButton.jsx
// "Reset" button shown next to Search in every filter bar. It clears the
// filters back to their defaults and searches again; it's greyed out when
// the filters are already at their defaults.
export default function ResetFiltersButton({ dirty, onReset }) {
  return (
    <button type="button" onClick={onReset} disabled={!dirty}
      style={dirty ? S.btn : { ...S.btn, ...S.off }}
      title={dirty ? 'Clear all filters and search again' : 'Filters are already cleared'}>
      ↺ Reset
    </button>
  );
}

// Filters differ from their defaults (arrays compared by content)
export function filtersDiffer(a, b) {
  return JSON.stringify(a) !== JSON.stringify(b);
}

const S = {
  btn: {
    padding: '8px 16px', background: 'var(--c-ffffff)', color: 'var(--t-37474f)', border: '1.5px solid var(--c-cfd8dc)',
    borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit',
    whiteSpace: 'nowrap'
  },
  off: { color: 'var(--c-b0bec5)', border: '1.5px solid var(--c-eceff1)', cursor: 'default' },
};
